// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1MutationReturn,
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalPayinSessionPrepareInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {payinSessionFragment} from 'src/api/graphql/payinSessionFragment';

import type {
  PayinSessionFragmentData,
  PayinSessionFragmentToken,
} from 'src/api/graphql/payinSessionFragment';

const doc = gql`
  mutation PrepareCryptoPurchaseMutation(
    $input: OpenapiPostV1CryptoInternalPayinSessionPrepareInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSessionPrepare(input: $input, v1Context: $v1Context) {
      id
      ...PayinSessionFragment
    }
  }
  ${payinSessionFragment}
`;
export const prepareCryptoPurchaseMutation: PrepareCryptoPurchaseMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const prepareCryptoPurchaseMutationOptions: V1MutationOptionsWithoutVariables<PrepareCryptoPurchaseMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function usePrepareCryptoPurchaseMutation<
  THookVariables extends HookVariables<PrepareCryptoPurchaseMutationVariables> = {},
>(
  options: V1MutationOptions<
    PrepareCryptoPurchaseMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<PrepareCryptoPurchaseMutationDocument, THookVariables> {
  return useV1Mutation(prepareCryptoPurchaseMutation, {
    ...prepareCryptoPurchaseMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PrepareCryptoPurchaseMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalPayinSessionPrepareInput>;
  v1Context: V1ContextInput;
}>;

export type PrepareCryptoPurchaseMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalPayinSessionPrepare: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
      readonly id: string;
    },
    [PayinSessionFragmentData]
  > | null;
};

export type PrepareCryptoPurchaseMutationToken = PayinSessionFragmentToken &
  AccountToken<{Mutation_v1CryptoInternalPayinSessionPrepare: true}>;

export type PrepareCryptoPurchaseMutationDocument = GraphQlDocument<
  PrepareCryptoPurchaseMutationData,
  PrepareCryptoPurchaseMutationVariables,
  PrepareCryptoPurchaseMutationToken
>;
